import { startCase } from 'es-toolkit';

import { ModelCategory, ParapetManualLoadSettings } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';

export const ParapetLoadSchema = new ModelSchema<ParapetManualLoadSettings>('parapetLoad', {
  category: ModelCategory.ComponentDesignData,
  pluralName: 'PAL Loads',
  displayName: (parapetLoad) => {
    if (parapetLoad.name) {
      return parapetLoad.name;
    }
    return startCase(parapetLoad.loadCaseALoads[0].memberType);
  },
  properties: {},
});
